import React, { useState } from 'react';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import AdminLayout from '../layout';
import OverviewTab from '../../../component/admin/FutureGifts/OverviewTab';
import BoxConfigTab from '../../../component/admin/FutureGifts/BoxConfigTab';
import GiftTypesTab from '../../../component/admin/FutureGifts/GiftTypesTab';
import ScheduledGiftsTab from '../../../component/admin/FutureGifts/ScheduledGiftsTab';

const FutureGiftsDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { admin, logout } = useAdminAuth();

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'box-config', label: 'Box Configuration' },
    { id: 'gift-types', label: 'Future Gift Types' },
    { id: 'scheduled', label: 'Scheduled Gifts & Timeline' }
  ];

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewTab refreshTrigger={refreshTrigger} onRefresh={handleRefresh} />;
      case 'box-config':
        return <BoxConfigTab refreshTrigger={refreshTrigger} onRefresh={handleRefresh} />;
      case 'gift-types':
        return <GiftTypesTab refreshTrigger={refreshTrigger} onRefresh={handleRefresh} />;
      case 'scheduled':
        return <ScheduledGiftsTab refreshTrigger={refreshTrigger} onRefresh={handleRefresh} />;
      default:
        return <OverviewTab refreshTrigger={refreshTrigger} onRefresh={handleRefresh} />;
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Tab Navigation */}
        <div className="flex border-b-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-8 py-4 text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab.id
                  ? 'border-[#55000C] text-[#55000C]'
                  : 'border-transparent text-[#6B635D] hover:text-[#1C2A46]'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="">
          {renderActiveTab()}
        </div>
      </div>
    </AdminLayout>
  );
};

export default FutureGiftsDashboard;